<template>
    <article>
        <h2>
            Basic Rules
        </h2>

        <div>
            <h3>
                Time
            </h3>

            <p>
                You have 10 seconds to answer each question. If you don't answer the question before your time is up, you get a strike!
            </p>
        </div>

        <div>
            <h3>
                Score
            </h3>

            <p>
                You gain points for every question you get correct, and you lose points for every question you get incorrect. If you don't answer a question, your score won't change, but you will get a strike. Easier questions earn you less points, while harder questions earn you more. The less time you take to answer a question, the more points you can receive from that question. Answer a question in less than 5 seconds, and you get double the possible points. But if you miss that question, you lose double the points. There are 4 levels of questions, and they usually coincide with the amount of digits in the numbers. Level 1 questions are worth 10 points. Level 2 questions are worth 25 points. Level 3 questions are worth 50 points. Level 4 questions are worth 100 points. For instance, if you get a level 2 question right, you gain 25 points. And if you get a level 1 question right in only 3 seconds, you get 20 points. However, if you get a level 3 question wrong, you lose 50 points. To win, you need to get 1,000 points.
            </p>
        </div>

        <div>
            <h3>
                Strikes
            </h3>

            <p>
                The only way to get a strike is to not answer a question. If you get 3 strikes, you lose. In fact, it's the only way you can lose. For instance, you can have -1,000,000 points but still be in the game. However, as soon as you hit 3 strikes, you're done.
            </p>
        </div>
    </article>
</template>
